const defineNetworkName = (chainId: number | null) : string => {
  switch (chainId) {
    case 137: return 'polygon'
    case 80001: return 'mumbai'
    case 8453: return 'base'
    default: return 'polygon'
  }
}

export default defineNetworkName